import { useRouter } from 'next/router'
import { useStaticData } from '@mc/static-data-react'
import {
  STRAIGHT_TO_QR_ENABLED_PATHS,
  STRAIGHT_TO_QR_EXCLUDED_SEGMENTS,
} from '../constants'

export const useCanGoStraightToQR = () => {
  const { asPath } = useRouter()
  const { ctaNextPage } = useStaticData<{
    ctaNextPage?: string
  }>()
  const isQuizCompleted = !!ctaNextPage

  const isOnEnabledPath =
    STRAIGHT_TO_QR_ENABLED_PATHS.some((path) => asPath?.startsWith(path)) &&
    !STRAIGHT_TO_QR_EXCLUDED_SEGMENTS.some((segment) =>
      asPath?.includes(segment),
    )

  return isOnEnabledPath && !isQuizCompleted
}
